import { getActionLabel } from "@/components/AccountSettings/v1/analyticsUtils"

export const getAddAnotherAddressAnalytics = () => {
  return JSON.stringify({
    clickInternalLinks: "true",
    eventAction:
      "my account:account settings:modal:add address:add another address",
    eventName:
      "my account:account settings:modal:add address:add another address",
    eventStatus: "n/a",
    eventMsg: "n/a",
    eventType: "navigation",
    internalLinkName: "add another address",
    internalLinkPosition: "my account",
    internalLinkType: "my account:addresses",
    internalLinkURL: "n/a",
    internalLinkZoneName: "my account:account settings:modal:add address",
  })
}

export const addAddAddressAnalytics = (
  status = "",
  errors = [],
  edit = false,
  actionLabel = ""
) => {
  const action = getActionLabel(actionLabel, edit)
  let eventMsg = "n/a"
  if (`${status}`.toLowerCase() !== "success") {
    if (Array.isArray(errors)) {
      if (errors.length) {
        eventMsg = errors.join("|").toLowerCase()
      }
    } else {
      const normalizedErrors = `${errors}`.trim()
      if (normalizedErrors) {
        eventMsg = normalizedErrors.toLowerCase()
      }
    }
  }
  const title = edit ? `edit address:${action}` : `add address:${action}`
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `my account:account settings:modal:${title}`,
    eventName: `my account:account settings:modal:${title}`,
    eventStatus: status,
    eventMsg,
    eventType: "navigation",
    internalLinkName: action,
    internalLinkPosition: edit
      ? "my account:account settings"
      : "account settings",
    internalLinkType: "my account:addresses",
    internalLinkURL: "n/a",
    internalLinkZoneName: `my account:account settings:modal:${
      edit ? "edit address" : "add address"
    }`,
    formName: "add address",
  }

  window?.adobeDataLayer?.push({
    event: "cmp:click",
    eventInfo,
  })
  delete window?.pageObj
}
